<script>
import LanguageSwitch from './LanguageSwitch';

export default {
    name: 'IntroSection',
    components: {
        LanguageSwitch,
    },
};
</script>

<template>
    <section class="intro">
        <language-switch />
    </section>
</template>

<style lang="scss" scoped>
.intro {
    position: relative;
    height: 100vh;

    @media (max-width: 960px) {
        height: 63vh;
    }
}
.lang-switch {
    position: absolute;
    top: 2rem; right: 1rem;
    z-index: 4;
}
</style>
